import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Deactivate: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px]', className)}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 19.9998C4.48372 19.9998 0 15.516 0 9.99976C0 4.48348 4.48372 -0.000244141 10 -0.000244141C15.5163 -0.000244141 20 4.48348 20 9.99976C20 15.516 15.5163 19.9998 10 19.9998ZM10 1.3951C5.25581 1.3951 1.39535 5.25557 1.39535 9.99976C1.39535 14.7439 5.25581 18.6044 10 18.6044C14.7442 18.6044 18.6047 14.7439 18.6047 9.99976C18.6047 5.25557 14.7442 1.3951 10 1.3951Z"
      fill="currentColor"
      strokeWidth="currentStrokeWidth"
    />
    <path
      d="M6 9.99976H14"
      stroke="currentColor"
      strokeWidth="currentStrokeWidth"
      strokeLinecap="round"
    />
  </svg>
);

export default Deactivate;
